import { observer } from 'mobx-react-lite'
import { FloatingPortal } from '@floating-ui/react-dom-interactions'

import { ReactComponent as AppIcon } from './icons/app-icon.svg'

import Styles from './ServiceWorkerUpdateModal.module.scss'
import { Button } from 'components/Button'
import { useServiceWorkerUpdate } from './ServiceWorkerUpdateStore'
import { useIsPwa } from 'utils/isPwa'
import { reloadPage } from 'utils/location'

export const ServiceWorkerUpdateModal = observer(function ServiceWorkerUpdateModal() {
  const store = useServiceWorkerUpdate()
  const onIgnore = () => store.ignore()
  const onOkay = reloadPage

  if (!useIsPwa() || !store.showDialog) return null

  return (
    <FloatingPortal id="floating-ui-root">
      <div className={Styles.wrapper} onClick={onIgnore}>
        <div className={Styles.dialog}>
          <div className={Styles.main}>
            <span className={Styles.title}>Blaze app update available</span>
            <div className={Styles.details}>
              <AppIcon className={Styles.appIcon} />
              <div className={Styles.detailsMain}>
                <span className={Styles.detailTitle}>There's a new version of the Blaze app!</span>
                <span className={Styles.detailText}>Refresh now for our latest update.</span>
                <span className={Styles.whatsNewWrapperMobile}>
                  See{' '}
                  <a className={Styles.whatsNewLink} target="_blank" rel="noreferrer" href="https://blaze.ai/whats-new">
                    what's new
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div className={Styles.footer}>
            <div className={Styles.whatsNewWrapper}>
              <span>See</span>
              <a target="_blank" rel="noreferrer" href="https://blaze.ai/whats-new">
                what's new
              </a>
            </div>
            <div className={Styles.footerControls}>
              <Button size="md" variant="none" onPress={onIgnore}>
                Later
              </Button>
              <Button size="md" variant="primary" onPress={onOkay}>
                Refresh
              </Button>
            </div>
          </div>
        </div>
      </div>
    </FloatingPortal>
  )
})
